/**
 * Aevum Theme — Main Frontend JS Entry Point
 */

import '../scss/main.scss';

import { initNavigation }     from './modules/navigation';
import { initStickyHeader }   from './modules/sticky-header';
import { initScrollAnimations } from './modules/scroll-animations';
import { initBackToTop }      from './modules/back-to-top';

document.addEventListener( 'DOMContentLoaded', () => {
	initNavigation();
	initStickyHeader();
	initScrollAnimations();
	initBackToTop();
} );
